import React from "react"

import { Flex } from "components/box"

import { PaginationPage, PaginationDots } from "."

type PaginationListProps = {
  handlePageClick: (value: number) => void
  showPenultimateItem: boolean
  handleLastItemClick: () => void
  handleDotsClick: () => void
  showLastItem: boolean
  currentPage: number
  pagesCount: number
  showDots: boolean
  items: number[]
}

export const PaginationList: React.FC<PaginationListProps> = ({
  handleLastItemClick,
  showPenultimateItem,
  handlePageClick,
  handleDotsClick,
  showLastItem,
  currentPage,
  pagesCount: lastItemCount,
  showDots,
  items
}) => {
  const penultimateItem = lastItemCount - 1
  const penultimateItemIndex = penultimateItem - 1

  const handlePenultimateItemClick = () => handlePageClick(penultimateItemIndex)

  return (
    <Flex alignItems="center">
      {items.map(index => (
        <PaginationPage
          key={`page-${index + 1}`}
          active={currentPage === index + 1}
          onClick={() => handlePageClick(index)}
        >
          {index + 1}
        </PaginationPage>
      ))}
      {showDots &&
        (showPenultimateItem ? (
          <PaginationPage onClick={handlePenultimateItemClick}>{penultimateItem}</PaginationPage>
        ) : (
          <PaginationDots bold onClick={handleDotsClick}>
            ...
          </PaginationDots>
        ))}
      {showLastItem && <PaginationPage onClick={handleLastItemClick}>{lastItemCount}</PaginationPage>}
    </Flex>
  )
}
